import r2wc from '@r2wc/react-to-web-component'
import FundProfileApp from './FundProfileApp/FundProfileApp'
import FundCatalogApp from './FundCatalogApp/FundCatalogApp'
import i18next from 'i18next'
import {initReactI18next} from 'react-i18next'
import resourcesToBackend from 'i18next-resources-to-backend'

i18next
    .use(
        resourcesToBackend({
            en: {
                common: {
                    'label.chart.tab.rate-of-return': 'Return rate',
                    'label.chart.tab.valuation': 'Unit value',
                    'label.btn.xlsx.download': 'Download table in XLSX',
                    'label.btn.xlsx.download.compare': 'Download comparison in XLSX',
                    'label.btn.xlsx.download.fund': 'Download quotations in XLSX',
                    'label.btn.pdf.download': 'Download PDF',
                    'label.btn.pdf.download.compare': 'Download in PDF',
                    'label.btn.pdf.download.fund': 'Download fund in PDF',
                    'label.pdf.ofe.performance': 'Fund performance',
                    'label.pdf.compare.title': 'Comparison of selected funds',
                    'label.pdf.compare.header.p1': 'Comparison',
                    'label.pdf.compare.header.p2': 'of selected funds',
                    'label.pdf.compare.compare.title': 'Fund comparison',
                    'label.pdf.compare.compare.alternative': 'Table with quotations of the compared funds',
                    'label.pdf.compare.profile.title': 'Fund performance',
                    'label.pdf.compare.profile.alternative': 'Table with fund quotations',
                    'label.pdf.compare.legend.alternative':
                        'Table containing the list of funds to be displayed on the chart',
                    'label.pdf.compare.chart.title': 'Funds chart',
                    'label.pdf.compare.chart.alternative': 'Chart displaying the quotation history of compared funds',
                    'label.pdf.profile.chart.title': 'Fund chart',
                    'label.pdf.common.timeline': 'Comparison downloaded',
                    'label.pdf.common.page': 'Page',
                    'label.xlsx.compare.filename': 'Fund comparison results',
                    'label.xlsx.common.generated': 'document generated on {{date}} at {{time}}',
                    'label.xlsx.common.currency': 'Currency',
                    'label.xlsx.common.value': 'Value',
                    'label.xlsx.common.date': 'Date',
                    'label.xlsx.common.fund': 'Fund',
                    'label.xlsx.common.history': 'quotation history',
                    'label.xlsx.profile.tab': 'Fund investment performance',
                    'label.xlsx.dfe': 'DFE funds',
                    'label.xlsx.list.filename.fio': 'Mutual funds',
                    'label.xlsx.list.title.fio': 'Mutual funds - quotations',
                    'label.xlsx.list.filename.ufk': 'UFK funds',
                    'label.xlsx.list.title.ufk': 'UFK funds - quotations',
                    'label.xlsx.list.filename.ofe': 'OFE funds',
                    'label.xlsx.list.title.ofe': 'OFE funds - quotations',
                    'label.xlsx.list.filename.dfe': 'DFE funds',
                    'label.xlsx.list.title.dfe': 'DFE funds - quotations',
                    'label.xlsx.compare.title.fio': 'Mutual funds - selected for comparison',
                    'label.xlsx.compare.title.ufk': 'UFK funds - selected for comparison',
                    'label.xlsx.legend.title': 'rates of return',
                    'label.filters.active': 'Your filters:',
                    'label.filters.clean': 'Clean',
                    'label.filters.more': 'More filters ({{count}})',
                    'label.column.valuation': 'Value',
                    'label.column.valuation.ofe': 'Unit value',
                    'label.column.unitCategory': 'Unit category',
                    'label.row.valuation': 'Unit value',
                    'label.row.btn.more': 'See more',
                    'label.infobox.favorites.append':
                        'Fund has been added to your favourites and moved to the top of the list',
                    'label.infobox.filters.save':
                        'Your filters, settings and range of information displayed have been retained from your previous visit.',
                    'label.infobox.filters.continue': 'You continue browsing with the same settings on this device.',
                    'label.infobox.multibonus': 'Important information regarding Multibonus insurance.',
                    'label.infobox.link': 'Find out more',
                    'label.infobox.unit.unreachable':
                        'Not all funds added to the comparison are still available. We have removed those that are no longer in our offer.',
                    'label.infobox.standardization.failed': 'Some selected funds have a shorter investment history.',
                    'label.infobox.current.quotes':
                        'Current pricing - current performance of funds as of the date of their last valuation. To check the returns as of a given date, select “As of date".',
                    'label.infobox.periods.switch':
                        'The quotation history of the selected funds is shorter than the previously set period. We have changed it automatically.',
                    'label.catalog.all.title': 'List of funds',
                    'label.catalog.select.qty': 'Show on page:',
                    'label.catalog.select.20': '20',
                    'label.catalog.select.50': '50',
                    'label.catalog.select.100': '100',
                    'label.catalog.select.all': 'all',
                    'label.catalog.tab.fio': 'TFI mutual funds',
                    'label.catalog.tab.ufk': 'UFK funds',
                    'label.catalog.tab.common': 'Compare funds ({{count}}/10)',
                    'label.catalog.btn.compare': 'Compare selected ({{count}}/10)',
                    'label.catalog.tab.compare.title': 'Display on chart',
                    'label.catalog.ofe.name': 'Open Pension Fund name',
                    'label.catalog.ofe.company.name': 'Company name',
                    'label.catalog.ofe.company.address': 'Open Pension Fund headquarters and address',
                    'label.catalog.ofe.krs': 'Number of General Pension Society from the register of companies',
                    'label.catalog.ofe.assets.date': 'Notice of net asset value and settlement unit value as of',
                    'label.catalog.ofe.assets.value': 'Net asset value',
                    'label.catalog.ofe.unit.value': 'Settlement unit value',
                    'label.compare.no-results.p1': 'You have no funds to compare.',
                    'label.compare.no-results.p2': 'Go to the funds tab and select those you want to compare.',
                    'label.compare.visible.fund': 'Funds to be displayed on the chart',
                    'label.compare.title': 'Funds chart',
                    'label.compare.unit.value': 'Unit value',
                    'label.compare.no.data': 'no data',
                    'label.compare.rate-of-return': 'Return rate',
                    'label.compare.datepicker.begin': 'Date from',
                    'label.compare.datepicker.end': 'Date to',
                    'label.datepicker.title': 'Date',
                    'label.datepicker.title2': 'As of date',
                    'label.datepicker.title3': 'Current pricing',
                    'label.datepicker.begin': 'Starting date',
                    'label.datepicker.end': 'Closing date (last day of valuation)',
                    'label.chart.select.period': 'Standardized periods',
                    'label.chart.legend.fund-started': 'Fund launch:',
                    'label.chart.legend.fund-last-quotation': 'Latest valuation:',
                    'label.chart.info.fund':
                        'For presentation and comparison purposes of the funds performance within the chart, the price values for the Allianz Euro Dochodowy unit have been converted from EUR to PLN at the average exchange rate of the National Bank of Poland on the valuation date.',
                    'label.datepicker.select-month-and-year': 'Select month and year',
                    'label.datepicker.select-year': 'Select year',
                    'label.datepicker.previous-month': 'Previous month',
                    'label.datepicker.next-month': 'Next month',
                    'label.datepicker.understand': 'Confirm',
                    'label.search.placeholder': 'Enter a name to search',
                    'label.search.title': 'Search',
                    'label.dropdown.select': 'Select',
                    'label.dropdown.select_one': '{{count}} selected',
                    'label.dropdown.select_other': '{{count}} selected',
                    'label.dropdown.rate-of-return.title': 'Show return rates (%)',
                    'label.dropdown.rate-of-return.subtitle': 'Return rates',
                    'label.dropdown.rate-of-return.clean': 'Reset',
                    'label.dropdown.rate-of-return.selected_one': '{{count}}/{{limit}} selected',
                    'label.dropdown.rate-of-return.selected_other': '{{count}}/{{limit}} selected',
                    'label.rows.length_one': 'Result: {{count}} fund',
                    'label.rows.length_other': 'Result: {{count}} funds',
                    'label.favourite.length_one': ', including {{count}} favourite',
                    'label.favourite.length_other': ', including {{count}} favourites',
                    'label.kind.title': 'Fund type',
                    'label.kind.FIO': 'Mutual funds (TFI)',
                    'label.kind.OFE': 'Open Pension Funds (OFE)',
                    'label.kind.DFE': 'Voluntary Pension Funds (DFE)',
                    'label.kind.UFK': 'Insurance Capital Funds (UFK)',
                    'label.kind.tooltip':
                        'Mutual funds, Insurance Capital Funds, Open Pension Funds, Voluntary Pension Funds',
                    'label.sri.title': 'SRI risk level',
                    'label.sri.1': '1 lowest',
                    'label.sri.2': '2 low',
                    'label.sri.3': '3 medium low',
                    'label.sri.4': '4 medium',
                    'label.sri.5': '5 medium high',
                    'label.sri.6': '6 high',
                    'label.sri.7': '7 highest',
                    'label.sri.tooltip':
                        'The risk of investing in funds is defined on the SRI scale, where 1 is the lowest risk and 7 is the highest risk',
                    'label.segment.title': 'Segment',
                    'label.segment.AKC': 'equities',
                    'label.segment.AKS': 'sector stocks and alternative investments',
                    'label.segment.OBL': 'bonds and debt',
                    'label.segment.SZM': 'stable growth, balanced, mixed',
                    'label.segment.PPK': 'PPK',
                    'label.segment.PMO': 'model portfolios',
                    'label.segment.POZ': 'other',
                    'label.product.ufk.title': 'Product',
                    'label.product.fio.title': 'Program',
                    'label.fund.fio.title': 'Fund',
                    'label.product.PAR_ALL01': 'Allianz FIO',
                    'label.product.PAR_ALL04': 'Allianz SFIO',
                    'label.product.PAR_ALL07': 'Allianz Plan Emerytalny SFIO',
                    'label.product.PAR_CUN02': 'Allianz Inwestycje SFIO',
                    'label.unitCategory.title': 'Unit category',
                    'label.unitCategory.A': 'A - freely transferable',
                    'label.unitCategory.B': 'B - available within certain products',
                    'label.unitCategory.C': 'C - available within certain products',
                    'label.unitCategory.CI': 'CI - investment certificate',
                    'label.unitCategory.CI(A)': 'CI(A) - investment certificate Series A',
                    'label.unitCategory.CI(B)': 'CI(B) - investment certificate Series B',
                    'label.unitCategory.CI(C)': 'CI(C) - investment certificate Series C',
                    'label.unitCategory.D': 'D - available within certain products',
                    'label.unitCategory.E': 'E - available within certain products',
                    'label.unitCategory.F': 'F - available within certain products',
                    'label.unitCategory.I': 'I - freely transferable',
                    'label.unitCategory.T': 'T - for the capital group members',
                    'label.unitCategory.Z': 'Z - freely transferable',
                    'label.unitCategory.tooltip':
                        'The participation unit category depends on the product or fund acquisition method and is related to the management fee charged',
                    'label.investmentHorizon.title': 'Investment horizon',
                    'label.investmentHorizon.1R': '1 year',
                    'label.investmentHorizon.2R': '2 years',
                    'label.investmentHorizon.3R': '3 years',
                    'label.investmentHorizon.4R': '4 years',
                    'label.investmentHorizon.5R': '5 years',
                    'label.investmentHorizon.6M': '6 months',
                    'label.investmentHorizon.tooltip':
                        'Recommended holding period for a given fund within an investment portfolio, proportional to the risk level',
                    'label.isEsg.title': 'ESG funds',
                    'label.esg.compliant.fund': 'ESG-compliant fund',
                    'label.esg.tooltip':
                        'Investing stategy that takes into account environmental, social responsibility and corporate governance factors in addition to the financial aspect',
                    'label.scroll.more': 'Scroll to view more',
                    'label.fund.fio.exclusively.allianz': 'Exclusively for Allianz companies',
                },
            },
            pl: {
                common: {
                    'label.chart.tab.rate-of-return': 'Stopa zwrotu',
                    'label.chart.tab.valuation': 'Wartość jednostki',
                    'label.btn.xlsx.download': 'Pobierz tabelę w XLSX',
                    'label.btn.xlsx.download.compare': 'Pobierz porównanie w XLSX',
                    'label.btn.xlsx.download.fund': 'Pobierz notowania w XLSX',
                    'label.btn.pdf.download': 'Pobierz PDF',
                    'label.btn.pdf.download.compare': 'Pobierz porównanie w PDF',
                    'label.btn.pdf.download.fund': 'Pobierz fundusz w PDF',
                    'label.pdf.ofe.performance': 'Wyniki funduszu',
                    'label.pdf.compare.title': 'Porównanie wybranych funduszy',
                    'label.pdf.compare.header.p1': 'Porównanie',
                    'label.pdf.compare.header.p2': 'wybranych funduszy',
                    'label.pdf.compare.compare.title': 'Porównanie funduszy',
                    'label.pdf.compare.compare.alternative': 'Tabela zawierająca notowania porównywanych funduszy',
                    'label.pdf.compare.profile.title': 'Wyniki funduszu',
                    'label.pdf.compare.profile.alternative': 'Tabela zawierająca notowania funduszu',
                    'label.pdf.compare.legend.alternative':
                        'Tabela zawierająca listę funduszy do wyświetlenia na wykresie',
                    'label.pdf.compare.chart.title': 'Wykres z funduszami',
                    'label.pdf.compare.chart.alternative': 'Wykres z historią notowań porównywanych funduszy',
                    'label.pdf.profile.chart.title': 'Wykres funduszu',
                    'label.pdf.common.timeline': 'Porównanie pobrano',
                    'label.pdf.common.page': 'Strona',
                    'label.xlsx.compare.filename': 'Wyniki porównania funduszy',
                    'label.xlsx.common.generated': 'dokument wygenerowany {{date}} o {{time}}',
                    'label.xlsx.common.value': 'Wartość',
                    'label.xlsx.common.currency': 'Waluta',
                    'label.xlsx.common.date': 'Data',
                    'label.xlsx.common.fund': 'Fundusz',
                    'label.xlsx.common.history': 'historia notowań',
                    'label.xlsx.profile.tab': 'Wyniki inwestycyjne funduszu',
                    'label.xlsx.dfe': 'Fundusze DFE',
                    'label.xlsx.list.filename.fio': 'Fundusze inwestycyjne',
                    'label.xlsx.list.title.fio': 'Fundusze inwestycyjne - notowania',
                    'label.xlsx.list.filename.ufk': 'Fundusze UFK',
                    'label.xlsx.list.title.ufk': 'Fundusze UFK - notowania',
                    'label.xlsx.list.filename.ofe': 'Fundusze OFE',
                    'label.xlsx.list.title.ofe': 'Fundusze OFE - notowania',
                    'label.xlsx.list.filename.dfe': 'Fundusze DFE',
                    'label.xlsx.list.title.dfe': 'Fundusze DFE - notowania',
                    'label.xlsx.compare.title.fio': 'Fundusze inwestycyjne - wybrane do porównania',
                    'label.xlsx.compare.title.ufk': 'Fundusze UFK - wybrane do porównania',
                    'label.xlsx.legend.title': 'stopy zwrotu',
                    'label.filters.active': 'Twoje filtry:',
                    'label.filters.clean': 'Resetuj',
                    'label.filters.more': 'Więcej filtrów ({{count}})',
                    'label.column.valuation': 'Wartość',
                    'label.column.valuation.ofe': 'Wartość jednostki',
                    'label.column.unitCategory': 'Kategoria jednostki',
                    'label.row.valuation': 'Wartość jednostki',
                    'label.row.btn.more': 'Więcej',
                    'label.infobox.favorites.append': 'Fundusz dodano do ulubionych i przeniesiono na początek listy',
                    'label.infobox.filters.save':
                        'Twoje filtry, ustawienia oraz zakres prezentowanych informacji zostały zachowane z poprzedniej wizyty.',
                    'label.infobox.filters.continue':
                        'Kontynuujesz przeglądanie z tymi samymi ustawieniami na tym urządzeniu.',
                    'label.infobox.multibonus': 'Ważne informacje dotyczące ubezpieczenia Multibonus.',
                    'label.infobox.link': 'Dowiedz się więcej',
                    'label.infobox.unit.unreachable':
                        'Nie wszystkie fundusze dodane do porównania są nadal dostępne. Usunęliśmy te, które nie znajdują się już w naszej ofercie.',
                    'label.infobox.standardization.failed':
                        'Niektóre wybrane fundusze mają krótszą historię inwestycyjną.',
                    'label.infobox.current.quotes':
                        'Bieżące wyceny – aktualne wyniki funduszy na datę ich ostatniej wyceny. Aby sprawdzić stopy zwrotu na dany dzień, wybierz "Na datę".',
                    'label.infobox.periods.switch':
                        'Historia notowań wskazanych funduszy jest krótsza od wybranego wcześniej okresu. Zmieniliśmy go automatycznie.',
                    'label.catalog.all.title': 'Lista funduszy',
                    'label.catalog.select.qty': 'Pokaż na stronie:',
                    'label.catalog.select.20': '20',
                    'label.catalog.select.50': '50',
                    'label.catalog.select.100': '100',
                    'label.catalog.select.all': 'wszystko',
                    'label.catalog.tab.fio': 'Fundusze inwestycyjne TFI',
                    'label.catalog.tab.ufk': 'Fundusze UFK',
                    'label.catalog.tab.common': 'Porównaj fundusze ({{count}}/10)',
                    'label.catalog.btn.compare': 'Porównaj zaznaczone ({{count}}/10)',
                    'label.catalog.tab.compare.title': 'Pokaż na wykresie',
                    'label.catalog.ofe.name': 'Nazwa Otwartego Funduszu Emerytalnego',
                    'label.catalog.ofe.company.name': 'Nazwa towarzystwa',
                    'label.catalog.ofe.company.address': 'Siedziba i adres Otwartego Funduszu Emerytalnego',
                    'label.catalog.ofe.krs': 'Numer Powszechnego Towarzystwa Emerytalnego z rejestru przedsiębiorców',
                    'label.catalog.ofe.assets.date':
                        'Zawiadomienie o wartości aktywów netto i wartości jednostki rozrachunkowej z dnia',
                    'label.catalog.ofe.assets.value': 'Wartość aktywów netto',
                    'label.catalog.ofe.unit.value': 'Wartość jednostki rozrachunkowej',
                    'label.compare.no-results.p1': 'Nie masz żadnych funduszy do porównania.',
                    'label.compare.no-results.p2': 'Przejdź do zakładki fundusze i zaznacz te do porównania.',
                    'label.compare.visible.fund': 'Fundusze do pokazania na wykresie',
                    'label.compare.title': 'Wykres z funduszami',
                    'label.compare.unit.value': 'Wartość jednostki',
                    'label.compare.no.data': 'brak danych',
                    'label.compare.rate-of-return': 'Stopa zwrotu',
                    'label.compare.datepicker.begin': 'Data od',
                    'label.compare.datepicker.end': 'Data do',
                    'label.datepicker.title': 'Data',
                    'label.datepicker.title2': 'Na datę',
                    'label.datepicker.title3': 'Bieżące wyceny',
                    'label.datepicker.begin': 'Data początkowa',
                    'label.datepicker.end': 'Data końcowa (ostatni dzień wyceny)',
                    'label.datepicker.understand': 'Zatwierdź',
                    'label.chart.select.period': 'Okresy standardowe',
                    'label.chart.legend.fund-started': 'Start funduszu:',
                    'label.chart.legend.fund-last-quotation': 'Najnowsza wycena: ',
                    'label.chart.info.fund':
                        'Dla celów prezentacji i możliwości porównania wyników funduszy na wykresie wartość ceny jednostki Allianz Euro Dochodowy przeliczona została z EUR na PLN wg średniego kursu NBP z dnia wyceny.',
                    'label.datepicker.select-month-and-year': 'Wybierz miesiąc i rok',
                    'label.datepicker.select-year': 'Wybierz rok',
                    'label.datepicker.previous-month': 'Poprzedni miesiąc',
                    'label.datepicker.next-month': 'Następny miesiąc',
                    'label.search.placeholder': 'Wpisz nazwę, aby wyszukać',
                    'label.search.title': 'Wyszukaj',
                    'label.dropdown.select': 'Wybierz',
                    'label.dropdown.select_few': '{{count}} wybrane',
                    'label.dropdown.select_many': '{{count}} wybranych',
                    'label.dropdown.rate-of-return.title': 'Pokaż stopy zwrotu (%)',
                    'label.dropdown.rate-of-return.subtitle': 'Stopy zwrotu',
                    'label.dropdown.rate-of-return.clean': 'Resetuj',
                    'label.dropdown.rate-of-return.selected_few': '{{count}}/{{limit}} wybrane',
                    'label.dropdown.rate-of-return.selected_many': '{{count}}/{{limit}} wybranych',
                    'label.rows.length_one': 'Wynik: {{count}} fundusz',
                    'label.rows.length_few': 'Wynik: {{count}} fundusze',
                    'label.rows.length_many': 'Wynik: {{count}} funduszy',
                    'label.favourite.length_one': ', w tym {{count}} ulubiony',
                    'label.favourite.length_few': ', w tym {{count}} ulubione',
                    'label.favourite.length_many': ', w tym {{count}} ulubionych',
                    'label.kind.title': 'Typ funduszu',
                    'label.kind.FIO': 'Fundusze Inwestycyjne (TFI)',
                    'label.kind.OFE': 'Otwarte Fundusze Emerytalne (OFE)',
                    'label.kind.DFE': 'Dobrowolne Fundusze Emerytalne (DFE)',
                    'label.kind.UFK': 'Ubezpieczeniowe Fundusze Kapitałowe (UFK)',
                    'label.kind.tooltip':
                        'Fundusze Inwestycyjne, Ubezpieczeniowe Fundusze Kapitałowe, Otwarty Fundusz Emerytalny, Dobrowolne Fundusze Emerytalne',
                    'label.sri.title': 'Poziom ryzyka SRI',
                    'label.sri.1': '1 najniższe',
                    'label.sri.2': '2 niskie',
                    'label.sri.3': '3 średnio niskie',
                    'label.sri.4': '4 średnie',
                    'label.sri.5': '5 średnio wysokie',
                    'label.sri.6': '6 wysokie',
                    'label.sri.7': '7 najwyższe',
                    'label.sri.tooltip':
                        'Ryzyko inwestowania w fundusze określone jest na skali SRI, gdzie 1 oznacza najniższe ryzyko, a 7 ryzyko najwyższe',
                    'label.segment.title': 'Segment',
                    'label.segment.AKC': 'akcyjne',
                    'label.segment.AKS': 'akcji sektorowych i alternatywnego inwestowania',
                    'label.segment.OBL': 'obligacyjne i dłużne',
                    'label.segment.SZM': 'stabilnego wzrostu, zrównoważone, mieszane',
                    'label.segment.PPK': 'PPK',
                    'label.segment.PMO': 'portfele modelowe',
                    'label.segment.POZ': 'pozostałe',
                    'label.product.ufk.title': 'Produkt',
                    'label.product.fio.title': 'Program',
                    'label.fund.fio.title': 'Fundusz',
                    'label.product.PAR_ALL01': 'Allianz FIO',
                    'label.product.PAR_ALL04': 'Allianz SFIO',
                    'label.product.PAR_ALL07': 'Allianz Plan Emerytalny SFIO',
                    'label.product.PAR_CUN02': 'Allianz Inwestycje SFIO',
                    'label.unitCategory.title': 'Kategoria jednostki',
                    'label.unitCategory.A': 'A - zbywalna bez ograniczeń',
                    'label.unitCategory.B': 'B - dostępna w określonych produktach',
                    'label.unitCategory.C': 'C - dostępna w określonych produktach',
                    'label.unitCategory.CI': 'CI - certyfikat inwestycyjny',
                    'label.unitCategory.CI(A)': 'CI(A) - certyfikat inwestycyjny Seria A',
                    'label.unitCategory.CI(B)': 'CI(B) - certyfikat inwestycyjny Seria B',
                    'label.unitCategory.CI(C)': 'CI(C) - certyfikat inwestycyjny Seria C',
                    'label.unitCategory.D': 'D - dostępna w określonych produktach',
                    'label.unitCategory.E': 'E - dostępna w określonych produktach',
                    'label.unitCategory.F': 'F - dostępna w określonych produktach',
                    'label.unitCategory.I': 'I - zbywalna bez ograniczeń',
                    'label.unitCategory.T': 'T - dla członów grupy kapitałowej',
                    'label.unitCategory.Z': 'Z - zbywalna bez ograniczeń',
                    'label.unitCategory.tooltip':
                        'Kategoria jednostek uczestnictwa zależy od produktu lub sposobu nabywania funduszy i jest związana z wysokością pobieranej opłaty za zarządzanie',
                    'label.investmentHorizon.title': 'Horyzont inwestycyjny',
                    'label.investmentHorizon.1R': '1 rok',
                    'label.investmentHorizon.2R': '2 lata',
                    'label.investmentHorizon.3R': '3 lata',
                    'label.investmentHorizon.4R': '4 lata',
                    'label.investmentHorizon.5R': '5 lat',
                    'label.investmentHorizon.6M': '6 miesięcy',
                    'label.investmentHorizon.tooltip':
                        'Proporcjonalny do poziomu ryzyka rekomendowany czas utrzymania danego funduszu w portfelu inwestycyjnym',
                    'label.isEsg.title': 'Fundusze z ESG',
                    'label.esg.compliant.fund': 'Fundusz zgodny z ESG',
                    'label.esg.tooltip':
                        'Lokowanie kapitału, które poza aspektem finansowym uwzględnia czynniki środowiskowe, społecznej odpowiedzialności i ładu korporacyjnego',
                    'label.scroll.more': 'Przewiń, aby zobaczyć więcej',
                    'label.fund.fio.exclusively.allianz': 'Wyłącznie dla spółek Allianz',
                },
            },
        })
    )
    .use(initReactI18next)
    .init({
        fallbackLng: 'pl',
        defaultNS: 'common',
        react: {
            transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'a'],
        },
        interpolation: {
            escapeValue: false,
        },
    })
    .then(() => {})

const FundProfileWebComponent = r2wc(FundProfileApp, {
    props: {
        contextconfiguration: 'json',
        customconfiguration: 'json',
        i18n: 'json',
    },
})

const FundCatalogWebComponent = r2wc(FundCatalogApp, {
    props: {
        contextconfiguration: 'json',
        customconfiguration: 'json',
        i18n: 'json',
    },
})

customElements.define('aol-profile', FundProfileWebComponent)
customElements.define('aol-catalog', FundCatalogWebComponent)
